import { shallowRef } from 'vue';
import { authState as authStateGlobal, waitUntilReady } from '@api-client/auth/auth';

export const authState = shallowRef(authStateGlobal.value);
export const authIsReady = shallowRef(false);

authStateGlobal.subscribe(s => authState.value = s);
waitUntilReady.then(() => {
    authIsReady.value = true;
});

export { waitUntilReady };